import { Outlet } from "react-router";
import { cn } from "../utils";

export const CenteredLayout = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div className={cn("pattern flex flex-col items-center justify-center min-h-dvh p-6 relative", className)} {...props}>
    <Outlet />
  </div>
);
